import { css } from '@emotion/core';

export default ({ classes, cybs }) => ({
  bg: css`
    ${classes && classes.skin
      ? classes.skin.bg.misc.white
      : 'background:white;'}
    flex-wrap: wrap;
    width: 100%;
    padding: 1rem;
    color: ${cybs?.base?.wcag21?.charcoal ?? '#000000'};
  `,
  pageTitle: css`
    font-size: 1.625rem;
    line-height: 2.25rem;
    letter-spacing: 0;
    font-weight: inherit;
    word-break: break-word;
    color: ${cybs?.base?.wcag21?.charcoal ?? '#000000'};

    ${classes && classes.structure
      ? classes.structure.margin.none.all
      : 'margin: 0;'};

    & ~ div {
      ${classes && classes.structure
        ? classes.structure.margin.space.top[2]
        : 'margin-top: 1rem;'}
    }
  `,
  helpText: css`
    ${classes && classes.structure
      ? classes.structure.margin.space.top[2]
      : 'margin-top: 1rem;'}
    color: ${cybs?.base?.wcag21?.charcoal ?? '#000000'};
  `,
  nav: css`
    ol {
      ${classes && classes.structure
        ? classes.structure.padding.space.left[0]
        : 'padding-left: 0;'}
      ${classes && classes.structure
        ? classes.structure.margin.space.bottom[0]
        : 'padding-left: 0;'}
    }
    ol > li {
      display: inline-block;
      span {
        word-break: break-word;
        white-space: normal;
      }
    }
  `,
  backButton: css`
    ${classes && classes.structure
      ? classes.structure.margin.space.left[1]
      : 'margin-left: 0.5rem;'}
    ${classes && classes.structure
      ? classes.structure.margin.space.top[1]
      : 'margin-top: 0.5rem;'}
    ${classes && classes.structure
      ? classes.structure.margin.space.bottom[2]
      : 'margin-bottom: 1rem;'} 
  `,

  rightButtonStyle: css`
    @media (max-width: 320px) {
      width: 100%;
    }
  `
});
